import Axios from 'axios';
import responseHandler from 'common/service/utils/responseHandler';
import errorHandler from 'common/service/utils/errorHandler';

export const YushengAxiosInstance = Axios.create({ baseURL: '/yusheng/api/v1' });
YushengAxiosInstance.interceptors.response.use(responseHandler, errorHandler);
